import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.css';

const Reference = ({ value }) => (
  <div className={styles.reference}>{value}</div>
);

Reference.propTypes = {
  value: PropTypes.string.isRequired,
};

export default Reference;
